var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.computedStyles.marginTop,
          expression: "computedStyles.marginTop",
        },
      ],
      staticClass: "gallery-item",
      class: {
        "focused-is-in-view": _vm.hasEverBeenFocused,
        "item--img": _vm.item.isVideo == false,
        "item--video": _vm.item.isVideo,
        "focus-visible": _vm.galleryVersion == "legacy",
        "img-loaded": _vm.imageLoaded,
        "is-in-view": _vm.isInView,
        "to-be-shown": _vm.item.visible,
      },
      style: _vm.computedStyles,
      attrs: {
        "data-aspect": _vm.item.aspect,
        role: "listitem",
        tabindex: "0",
        "data-id": _vm.item.id,
        "aria-haspopup": "dialog",
      },
      on: {
        isInView: _vm.onItemIsInView,
        focus: _vm.onFocus,
        blur: _vm.onBlur,
        click: function ($event) {
          return _vm.onItemClick(_vm.item)
        },
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          return _vm.onItemClick(_vm.item)
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "gallery-item__inner" },
        [
          _vm.item.isVideo
            ? [
                _c("gallery-video", {
                  key: `video-${_vm.item.id}`,
                  attrs: {
                    item: _vm.item,
                    mode: "thumbnail",
                    "is-parent-focused": _vm.hasFocus,
                  },
                }),
              ]
            : [
                _c("div", [
                  _c("picture", { attrs: { "data-type": "list" } }, [
                    _c("source", {
                      attrs: {
                        media: "(min-width: 1800px)",
                        "data-srcset-observer": `${
                          _vm.listingImageUrl
                        }?width=${_vm.getImageSrcSetSize("> 1800")}`,
                      },
                    }),
                    _vm._v(" "),
                    _c("source", {
                      attrs: {
                        media: "(min-width: 1440px) and (max-width: 1799px)",
                        "data-srcset-observer": `${
                          _vm.listingImageUrl
                        }?width=${_vm.getImageSrcSetSize("> 1440 && < 1799")}`,
                      },
                    }),
                    _vm._v(" "),
                    _c("source", {
                      attrs: {
                        media: "(min-width: 1200px) and (max-width: 1439px)",
                        "data-srcset-observer": `${
                          _vm.listingImageUrl
                        }?width=${_vm.getImageSrcSetSize("> 1200 && < 1439")}`,
                      },
                    }),
                    _vm._v(" "),
                    _c("source", {
                      attrs: {
                        media: "(min-width: 992px) and (max-width: 1199px)",
                        "data-srcset-observer": `${
                          _vm.listingImageUrl
                        }?width=${_vm.getImageSrcSetSize("> 992 && < 1199")}`,
                      },
                    }),
                    _vm._v(" "),
                    _c("source", {
                      attrs: {
                        media: "(min-width: 768px) and (max-width: 991px)",
                        "data-srcset-observer": `${
                          _vm.listingImageUrl
                        }?width=${_vm.getImageSrcSetSize("> 768px && < 991")}`,
                      },
                    }),
                    _vm._v(" "),
                    _c("source", {
                      attrs: {
                        media: "(min-width: 540px) and (max-width: 767px)",
                        "data-srcset-observer": `${
                          _vm.listingImageUrl
                        }?width=${_vm.getImageSrcSetSize(
                          "> 540 && < 767 x1"
                        )} 1x, ${
                          _vm.listingImageUrl
                        }?width=${_vm.getImageSrcSetSize(
                          "> 540 && < 767 x2"
                        )} 2x`,
                      },
                    }),
                    _vm._v(" "),
                    _c("source", {
                      attrs: {
                        media: "(max-width: 539px)",
                        "data-srcset-observer": `${
                          _vm.listingImageUrl
                        }?width=${_vm.getImageSrcSetSize("< 539 x1")} 1x, ${
                          _vm.listingImageUrl
                        }?width=${_vm.getImageSrcSetSize("< 539 x2")} 2x`,
                      },
                    }),
                    _vm._v(" "),
                    _c("img", {
                      staticClass: "asset-img",
                      attrs: {
                        src: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",
                        "data-src-observer": `${_vm.listingImageUrl}?width=600`,
                        width: _vm.item.imageWidth,
                        height: _vm.item.imageHeight,
                        alt: _vm.item.imageAlternativeText,
                        "aria-label": _vm.item.imageAlternativeText,
                      },
                      on: { imgNowLoaded: _vm.onImageLoaded },
                    }),
                  ]),
                ]),
              ],
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }